/**
 * @generated SignedSource<<578d6dcc62437ff837b5e02ee506ce05>>
 * @relayHash b43985c42b7a9585a2a68c0f9d29913c
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b43985c42b7a9585a2a68c0f9d29913c

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrinkingHabit = "DAILY" | "FOUR_TO_FIVE_PER_WEEK" | "LESS_THAN_ONE_TIMES_PER_WEEK" | "NEVER" | "NOT_SPECIFIED" | "NO_LONGER" | "ONE_TO_THREE_PER_WEEK";
export type SmokingHabit = "IN_COMPANY" | "NEVER" | "NOT_SPECIFIED" | "NO_LONGER" | "REGULARLY";
export type Ch_updatePatientSocialHistoryInput = {
  comment?: string | null;
  drinkingHabit: DrinkingHabit;
  patientId: string;
  smokingHabit: SmokingHabit;
};
export type chUpdatePatientSocialHistoryMutation$variables = {
  input: Ch_updatePatientSocialHistoryInput;
};
export type chUpdatePatientSocialHistoryMutation$data = {
  readonly updatePatientSocialHistory: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly patientId?: string;
    }> | null;
    readonly socialHistory: {
      readonly " $fragmentSpreads": FragmentRefs<"SocialHistoryFragment">;
    } | null;
  };
};
export type chUpdatePatientSocialHistoryMutation = {
  response: chUpdatePatientSocialHistoryMutation$data;
  variables: chUpdatePatientSocialHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*:: as any*/)
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "PatientNotFound",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdatePatientSocialHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientSocialHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientSocialHistoryPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientSocialHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SocialHistoryFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chUpdatePatientSocialHistoryMutation",
    "selections": [
      {
        "alias": "updatePatientSocialHistory",
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_updatePatientSocialHistoryPayload",
        "kind": "LinkedField",
        "name": "ch_updatePatientSocialHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialHistory",
            "kind": "LinkedField",
            "name": "socialHistory",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "comment",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drinkingHabit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "smokingHabit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "b43985c42b7a9585a2a68c0f9d29913c",
    "metadata": {},
    "name": "chUpdatePatientSocialHistoryMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5b51094f0facc1b7ae4c31fbee8c4be4";

export default node;
